export const CHARACTERISTICS_OVERVIEW = `
query CharacteristicsOverview { 
characteristics { 
  id
    shortcut
    unit {name}
    dataType
  masterSort
    localizedKey
    category
    isCritical
  }
}
`
